module.exports = __webpack_public_path__ + "img/u16.fa8d5e5b.png";